export default [
  {
    title: '标签ID',
    key: 'labelId',
    width: 48
  },
  {
    title: '标签内容',
    key: 'content',
    width: 220
  },
  {
    title: '关联素材数',
    key: 'relatedMaterialsNum',
    width: 70
  },
  {
    title: '关联游戏',
    key: 'gameNames',
    width: 120,
    overflow: true
  },
  {
    title: '创建人',
    key: 'createOpName'
  },
  {
    title: '更新人',
    key: 'upOpName',
    width: 64
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: 180
  },
  {
    title: '更新时间',
    key: 'upTime',
    width: 180
  },
  {
    title: '操作',
    key: 'control',
    width: 60
  }
]

export const imageStyleCols = [
  {
    title: '素材样式ID',
    key: 'labelId',
    width: 60
  },
  {
    title: '样式内容',
    key: 'content',
    width: 220
  },

  {
    title: '层级',
    key: 'level',
    width: 50
  },

  {
    title: '上级素材样式',
    key: 'parentLabel',
    width: 90
  },

  {
    title: '关联素材数',
    key: 'relatedMaterialsNum',
    width: 70
  },

  {
    title: '关联游戏',
    key: 'gameNames',
    width: 120,
    overflow: true
  },
  {
    title: '创建人',
    key: 'createOpName'
  },
  {
    title: '更新人',
    key: 'upOpName',
    width: 64
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: 180
  },
  {
    title: '更新时间',
    key: 'upTime',
    width: 180
  },
  {
    title: '操作',
    key: 'control',
    width: 60
  }
]
